<div id="section-pc">
  <div class="linear-diagonal"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12 text-center">
        <h1>{{ titleKey | translate }}</h1>
        <h4>{{ subtitleKey | translate }}</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 text-center">
        <img id="laptop" src="..\assets\img\laptop.png" alt="" />
      </div>
      <div class="col-lg-6 text-center">
        @for (item of items; track item) {
          <div class="item-laptop">
            <div class="icon">
              <fa-icon [icon]="item.icon"></fa-icon>
            </div>
            <div class="item-body">
              <h3>{{ item.titleKey | translate }}</h3>
              <p>{{ item.textKey | translate }}</p>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
  <div class="linear"></div>
</div>
